import pl from "./pl.json";
import en from "./en.json";

export default {
  pl,
  en,
};
